// extracted by mini-css-extract-plugin
export default {"headContainer":"notes-module--headContainer--1YKui","notesContainer":"notes-module--notesContainer--2sUg0","pageMetadata":"notes-module--pageMetadata--1kL33"};